// extracted by mini-css-extract-plugin
module.exports = {"boardContainer":"Board_boardContainer__15JVx","boardWrapper":"Board_boardWrapper__piyHW","exit":"Board_exit__1G8i5","exitText":"Board_exitText__1d-eU"};